/* @flow */

import {combineReducers} from 'redux';
import {createReducer} from 'redux-act';
import type {ListItem} from 'nutshell-core/types';

import * as actions from './custom-segment-actions';

type CustomSegmentListState = {
    isLoading: boolean,
    isFirstLoad: boolean,
    errorMessage?: string,
    listItems: Object[],
    meta: Object,
};

const customSegmentListDefaultState = {
    isLoading: true,
    isFirstLoad: true,
    errorMessage: undefined,
    listItems: [],
    meta: {},
};

const isFilterDrawerOpen = createReducer(
    {
        [actions.toggleShowFilterDrawer]: (state) => !state,
    },
    false
);

export const customSegmentListReducer = createReducer(
    {
        // $FlowIgnore - this works correctly from redux-act
        [actions.requestCustomSegmentListData]: (state) => {
            return {...state, isLoading: true, errorMessage: undefined};
        },
        [actions.updateCustomSegmentListData]: (state, {meta, listItems}) => {
            return {
                ...state,
                isLoading: false,
                isFirstLoad: false,
                meta: meta,
                listItems: listItems
                    ? listItems.map((item: ListItem) => {
                          return {
                              ...item,
                              id: item.links ? item.links.entity.id : item.id,
                          };
                      })
                    : undefined,
                errorMessage: undefined,
            };
        },
        [actions.failCustomSegmentListData]: (state, err) => {
            return {...state, isLoading: false, isFirstLoad: false, errorMessage: err};
        },
    },
    customSegmentListDefaultState
);

// $FlowFixMe upgrading Flow to v0.92.1 on web
export const customSegmentReducer = combineReducers({
    customSegmentList: customSegmentListReducer,
    isFilterDrawerOpen,
});

export type CustomSegmentState = {
    customSegmentList: CustomSegmentListState,
    isFilterDrawerOpen: boolean,
};
